import { SetStateAction, Dispatch } from 'react'
import { useLocation } from 'react-router-dom'
import { Annotations } from '@pdftron/webviewer'
import { useQuery } from '@apollo/client'
import ImDfmPdfViewer, {
    ViewerModeType,
} from '@Admin/AdminQuotingPage/ModelViewerPanel/ImDfmModePanel/ImDfmPdfViewer'
import {
    SLIDE_QUERY_PARAM,
    MODE_QUERY_PARAM,
} from '@Admin/AdminQuotingPage/constants'

import { useExtractUrlSearchParams } from '~/lib/extractUrlSearchParams'

import imDfmPdfViewerQuery from './imDfmPdfViewerQuery'

interface PropsType {
    attachmentId: string
    qmrAttachmentAnnotationsUrl?: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setCurrentPdfData: Dispatch<SetStateAction<any>>
    setUnsavedAnno: Dispatch<SetStateAction<Annotations.Annotation[]>>
    unsavedAnno: Annotations.Annotation[]
}

const ImDfmModalPdfViewer = (props: PropsType) => {
    const {
        attachmentId,
        qmrAttachmentAnnotationsUrl,
        setCurrentPdfData,
        setUnsavedAnno,
        unsavedAnno,
    } = props

    const { search } = useLocation()

    const searchParams = useExtractUrlSearchParams(search, [
        SLIDE_QUERY_PARAM,
        MODE_QUERY_PARAM,
    ])

    const dfmFeedbackId = searchParams[SLIDE_QUERY_PARAM]
    const viewerMode = searchParams[MODE_QUERY_PARAM] as ViewerModeType

    const { data: dfmFeedbackData } = useQuery(imDfmPdfViewerQuery, {
        variables: { dfmFeedbackId },
        skip: !dfmFeedbackId,
    })

    const attachment = dfmFeedbackData?.dfmFeedback?.attachment
    const fileName = attachment?.fileName
    const pdfUrl = attachment?.downloadUrl

    return (
        <ImDfmPdfViewer
            attachmentId={attachmentId}
            fileName={fileName}
            isLocatedInModal
            viewerMode={viewerMode}
            pdfName={fileName}
            pdfUrl={pdfUrl}
            qmrAttachmentAnnotationsUrl={qmrAttachmentAnnotationsUrl}
            setCurrentPdfData={setCurrentPdfData}
            setUnsavedAnno={setUnsavedAnno}
            unsavedAnno={unsavedAnno}
        />
    )
}

export default ImDfmModalPdfViewer
